import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import SoftSelect from "components/SoftSelect";
import { Box } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";


function PrePayment({ selectedModeType, handleClose, onClick, onDateChange }) {
  const [modeType, setModeType] = useState("");
  const [email, setEmail] = useState("");
  const [balance, setBalance] = useState("");
  const [reason, setReason] = useState("");

  const [selectedStartDate, setSelectedStartDate] = useState(dayjs());
  const [selectedEndDate, setSelectedEndDate] = useState(dayjs());

  const [anchorStart, setAnchorStart] = useState(null);
  const [anchorEnd, setAnchorEnd] = useState(null);

  const modeOptions = [
    { value: "Cash", label: "Cash" },
    { value: "Bank", label: "Bank" },
  ];

  useEffect(() => {
    if (selectedModeType) setModeType(selectedModeType);
  }, [selectedModeType]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      modeType,
      startDate: selectedStartDate.format("YYYY-MM-DD"),
      endDate: selectedEndDate.format("YYYY-MM-DD"),
      email,
      reason,
    });
  };

  const handlePrevDay = (type) => {
    if (type === "start") setSelectedStartDate((prev) => prev.subtract(1, "day"));
    else setSelectedEndDate((prev) => prev.subtract(1, "day"));
  };

  const handleNextDay = (type) => {
    if (type === "start") setSelectedStartDate((prev) => prev.add(1, "day"));
    else setSelectedEndDate((prev) => prev.add(1, "day"));
  };

  const handleOpenCalendar = (event, type) => {
    if (type === "start") setAnchorStart(event.currentTarget);
    else setAnchorEnd(event.currentTarget);
  };

  const handleCloseCalendar = (type) => {
    if (type === "start") setAnchorStart(null);
    else setAnchorEnd(null);
  };


  return (
    <Card>
      <SoftBox p={3}>
        {/* Header */}
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <SoftTypography variant="h5">Add new Pre payment</SoftTypography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </SoftBox>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">User</SoftTypography>
            <SoftInput type="text" placeholder="Enter user" />
          </SoftBox>

          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Amount</SoftTypography>
            <SoftInput type="text" placeholder="Enter Amount" />
          </SoftBox>

          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Date</SoftTypography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              border={1}
              borderRadius={2}
              borderColor="#ced4da"
              px={2}
              minHeight="42px"
            >
              <Typography
                fontWeight="medium"
                fontSize={16}
                color={selectedStartDate ? "text.secondary" : "text.primary"}
              >
                {selectedStartDate ? selectedStartDate.format("DD-MMM-YYYY") : "Select date"}
              </Typography>

              <IconButton onClick={(e) => handleOpenCalendar(e, "start")}>
                <CalendarTodayIcon />
              </IconButton>

              <Popover
                open={Boolean(anchorStart)}
                anchorEl={anchorStart}
                onClose={() => handleCloseCalendar("start")}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                PaperProps={{
                  sx: { backgroundColor: "#fff", borderRadius: 2, boxShadow: 3, p: 1 },
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateCalendar
                    value={selectedStartDate}
                    minDate={dayjs()}
                    onChange={(newValue) => {
                      setSelectedStartDate(newValue);
                      handleCloseCalendar("start");
                      if (onDateChange) onDateChange(newValue);
                    }}
                  />
                </LocalizationProvider>
              </Popover>
            </Box>
          </SoftBox>

          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Payment Mode</SoftTypography>
            <SoftSelect
              placeholder="Select"
              value={{ value: modeType, label: modeType }}
              options={modeOptions}
              onChange={(selectedOption) => setModeType(selectedOption.value)}
            />
          </SoftBox>

          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Deduct from Payroll</SoftTypography>
            <SoftInput
              type="email"
              placeholder="Enter amount"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </SoftBox>

          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Notes</SoftTypography>
            <TextField
              fullWidth
              multiline
              rows={3}
              placeholder="Notes"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </SoftBox>
            <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Balance</SoftTypography>
            <SoftInput type="text" 
            placeholder="Your Balance" 
             value={balance}
              onChange={(e) => setBalance(e.target.value)}
              />
          </SoftBox>

          <SoftBox display="flex" gap={2} mt={3}>
            <SoftButton type="submit" variant="gradient" color="info">Create</SoftButton>
            <SoftButton type="button" variant="outlined" color="secondary" onClick={handleClose}>Cancel</SoftButton>
          </SoftBox>
        </form>
      </SoftBox>
    </Card>
  );
}

PrePayment.propTypes = {
  selectedModeType: PropTypes.string,
  handleClose: PropTypes.func,
  onDateChange: PropTypes.func,
  onClick: PropTypes.func,
};

export default PrePayment;
